// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-dialog[data-v-5baa970a] {\n  width: 30%;\n}\n.el-dialog .dialog-footer[data-v-5baa970a] {\n  margin-top: 0px;\n  padding-top: 0px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
